import { NotificationsService } from './../../Services/shared/notifications.service';
import { SuggestedPriceRequest, ConsignmentService, GalleryConsignmentProduct, GalleryDescriptionRequest } from './../../Services/consignment.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, Renderer2, ViewChild, DOCUMENT } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { ProductsStatusFiltersType, ProductsStatusFilters, ArtistProductsService, CoverPhotoResponse, GalleryDescriptionResponse, ArtistProductsSummaryRequest } from 'src/app/Services/artistproducts.service';
import { AuthConfig, AuthService, FacebookApiresponceObject, ResponseObject, proBySourceEnum, } from 'src/app/Services/auth.service';
import { NotificationTypes } from 'src/app/app.enums';
import { ArtistsService } from 'src/app/Services/artists.service';
import { ProductSyncedOnPlatformDTO, ViewArtistProductResponse } from 'src/app/models/viewartistproductresponse.model';
import { FacebookAccount, FaceBookOuthPage, FaceBookOuthPages, FacebookPostPublish, FacebookProfie, FacebookSocialPost, InstagramAccountDetail, InstagramAccountsApiResponce, InstagramOuthPage, ResponeObject, SocialPost, SocialPostData, SoicalPost } from 'src/app/models/socialpost.model';
import { ProductSoldRequest } from 'src/app/models/request/productsoldrequest.model';
import { Meta, Title } from '@angular/platform-browser';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { SocialPostService } from 'src/app/Services/social-post.service';
import { ArtistProductImage } from 'src/app/models/artistproduct.model';
import { CloudinaryImageService } from 'src/app/Services/cloudinary-image.service';
import { ImageCroppedResponse } from '../image-cropper/image-cropper.component';
import { FileUpload, UploadEvent } from 'primeng/fileupload';
import { GeneratedProductDescriptionsSuggestions } from '../chatgpt-dialog/chatgpt-dialog.component';
import { SquareUpOAuthTokken, SquareupPosService, SyncArtworkPermission } from 'src/app/Services/squareup-pos.service.ts/squareup-pos.service';
import { ShopifyOAuthToken, ShopifyService } from 'src/app/Services/shopify-service/shopify.service';
import { WoocomerceService, WoocommerceCredentials } from 'src/app/Services/woocomerce-service/woocomerce.service';
import { StripePlans } from 'src/app/models/stripe.model';
import { CurrencyData, WixService } from 'src/app/Services/Wix-Service/wix.service';
import { ConnectSquareupPosAccountComponent } from 'src/app/components/connect-squareup-pos-account/connect-squareup-pos-account.component';
import { WixComponent } from 'src/app/components/connect-with-wix/wix.component';
import { ConnectWoocommerceAccountComponent } from 'src/app/components/gallery-components/connect-woocommerce-account/connect-woocommerce-account.component';
import { ShopifyAccount } from 'src/app/components/gallery-components/shopify-account/shopify-account.component';
import { InstagramService } from 'src/app/Services/instagram.service';
import { FacebookService } from 'src/app/Services/facebook.service';
import { SquareSpaceService } from 'src/app/Services/square-space/square-space.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'view-artwork',
    templateUrl: './view-artwork.component.html',
    styleUrls: ['./view-artwork.component.css'],
    providers: [ArtistProductsService, ArtistsService, ConsignmentService, MessageService],
    standalone: false
})
export class ViewArtworkComponent implements OnInit, AfterViewInit {
  @ViewChild('additionalFileUploadCmp') additionalFileUploadCmp!: FileUpload;
  public isAuthenticated: boolean = false;
  public showFullScreenImage = false;
  public galleria = true;
  public platform !: string
  public magnification = 2; // Zoom magnification factor
  showEdit: string | null = null;
  public circularLens = true;
  public authConfig!: AuthConfig;
  public artistId!: string;
  public UserNmae?: string;
  public consignedProduct: SuggestedPriceRequest = {} as SuggestedPriceRequest;
  public galleryDescription: GalleryDescriptionRequest = {} as GalleryDescriptionRequest;
  public selectedItem: ViewArtistProductResponse = {} as ViewArtistProductResponse;
  public selectedProductId!: string | null;
  public ReleventProduct: ViewArtistProductResponse[] = [];
  public items: MenuItem[] | undefined;
  public home: MenuItem | undefined;
  public isProductAvailable: boolean = true;
  public isProductSold: boolean = true;
  public productStatus: ProductsStatusFiltersType = ProductsStatusFilters.Available;
  public productSoldData: ProductSoldRequest = {};
  public isProductSoldDialogVisible: boolean = false;
  public isProductShareDailogVisible: boolean = false;
  public isFacebookPagesDailogVisible: boolean = false;
  public isInstagramPagesDailogVisible: boolean = false
  public isTabsVisible: boolean = true
  public events!: any[];
  public sidebarVisible: boolean = false;
  public shopifyLinksDialogVisible: boolean = false;
  public wooCommerceLinksDialogVisible: boolean = false;
  public squareSpaceLinksDialogVisible: boolean = false;
  public sidebarActivityLogsVisible = false;
  public proBySourceEnum: any = proBySourceEnum;
  public selectedTabIndex: number = 0;
  public isSocialPostDailogVisible: boolean = false;
  public socialPosts: SocialPost[] = [
    {
      Id: "",
      PostId: "",
      PostedOn: "",
      HeadLine: "",
      Description: "",
      ImageURL: "",
      UserId: "",
      CreatedDate: new Date(),
      SocialMediaInsights: {
        TotalLikes: 0,
        TotalShares: 0,
        TotalComments: 0
      },
      FacebookAccount: {
        FacebookProfileName: "",
        FacebookProfilePicture: "",
        FaceBookPageId: "",
        PageIsActive: false,
        FacebookPageName: "",
        FacebookPagePicture: "",
        PageAccessTokken: ""
      },
      InstagramAccount: {
        PageIsActive: false,
        InstagramPageId: "",
        InstagramPageName: "",
        InstagramPagePicture: "",
        PageAccessTokken: "",
      },
      UserName: "",
      UserBusinessName: "",
      UserEmail: "",
      UserImgUrl: "",
      ProductId: "",
      IsArtist: false,
      ProductName: "",
      PostedBy: "",
      ArtistId: ""
    }
  ];
  public SocialPost: SoicalPost = {} as SoicalPost;
  public facebookPost: FacebookPostPublish = {} as FacebookPostPublish;
  RelevantProducts: ViewArtistProductResponse[] = []
  public socialAccount: SocialPostData = {} as SocialPostData;
  public displayCurrencyDialog: boolean = false
  public exchangeRateData: CurrencyData | null = null;
  public AccountOf: SelectItem[] = [
    { label: 'Facebook', value: 'Facebook' },
    { label: 'Instagram', value: 'Instagram' }
  ];
  // for Accounts pages
  public facebookPages: FaceBookOuthPages[] = [];
  public FacebookAccountName!: string;
  public FacebookAccountImageUrl!: string;
  public FacebookAccountEmail!: string;
  public selectedFacebookPage: FaceBookOuthPages | undefined;
  public instagramPages: InstagramOuthPage[] = [];
  public selectedinstagramPage: InstagramOuthPage | undefined;
  // for facebook accounts
  public facebookAccounts: SocialPostData[] = [];
  public selectedFacebookAccount: SocialPostData | undefined;
  // for instagram accounts
  public instagramAccounts: InstagramAccountsApiResponce[] = [];
  public selectedInstagramAccount: InstagramAccountsApiResponce | undefined
  // for page ids
  public facebookPageId!: string | null;
  public instagramPageId!: string | null;
  // account ids
  public facebookAccountsId!: string | null;
  public instagramAccountsId!: string | null;
  public currentSelectedImage?: File;
  public isAdditionalImage: boolean = false;
  public productImages: ArtistProductImage[] = [];
  public selectedFile!: File;
  public selectedUserId: string | null = null;
  public userId!: string;
  public enableCropper: boolean = true;
  public currentSelectedImageToCrop?: File;
  public showCropperDialog: boolean = false;
  public productImage!: ArtistProductImage
  @ViewChild('additionalFileUploadComplete') additionalFileUploadComplete!: FileUpload;
  @ViewChild('imageZoom') imageZoom!: ElementRef;
  // @ViewChild(WixComponent, { static: false }) wixComponent: WixComponent | undefined;
  // @ViewChild(ConnectSquareupPosAccountComponent, { static: false }) squareComponent: ConnectSquareupPosAccountComponent | undefined;
  @ViewChild(ShopifyAccount, { static: false }) shopifyComponent: ShopifyAccount | undefined;
  @ViewChild(ConnectWoocommerceAccountComponent, { static: false }) woocommerceComponent: ConnectWoocommerceAccountComponent | undefined;
  public showchatGPTDialog: boolean = false
  public isFreePlanUser: boolean = true
  public isProfileDialogVisible: boolean = false;
  public IsAllowedToSyncProductsOnShopify: boolean = false;
  public IsAllowedToSyncProductsOnSquareUp: boolean = false;
  public IsAllowedToSyncProductsOnWooCommerce: boolean = false;
  public IsAllowedToSyncProductsOnWix: boolean = false;
  public checkAccountExitsOnWix: boolean = false;
  public squareUpAccount: SquareUpOAuthTokken = {} as SquareUpOAuthTokken;
  public wooCommerceAccount: WoocommerceCredentials = {} as WoocommerceCredentials;
  public shopifyAccount: ShopifyOAuthToken = {} as ShopifyOAuthToken;
  public artworkSyncData: SyncArtworkPermission = {} as SyncArtworkPermission;
  public stripePlans: StripePlans[] = [];
  public isStripeDisplayPlansDialogVisible: boolean = false;
  public isSentByEditProfile: boolean = true;
  public isAddWoocommerceAccountDailogVisible: boolean = false;
  public isShopifyConnectionDailogVisible: boolean = false
  public isSquarePos!: boolean;
  public isShopify!: boolean;
  public isWoocommerce!: boolean;
  public isWix!: boolean;
  public isFacebook!: boolean;
  public isInstagram!: boolean;
  public checkAccountOnSquareSpace: boolean = false;

  constructor(@Inject(PLATFORM_ID) readonly platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    private authService: AuthService,
    private renderer: Renderer2,
    private ArtistProductsService: ArtistProductsService,
    private consignmentProductService: ConsignmentService,
    private notificationsService: NotificationsService,
    private ngxSpinnerService: NgxSpinnerService,
    private titleService: Title,
    private metaService: Meta,
    private router: Router,
    private squareupPosService: SquareupPosService,
    private SocialPostService: SocialPostService,
    private confirmationService: ConfirmationService,
    private uploadService: CloudinaryImageService,
    private messageService: MessageService,
    private ShopifyService: ShopifyService,
    private wixService: WixService,
    private instagramService: InstagramService,
    private WoocomerceService: WoocomerceService,
    private facebookService: FacebookService,
    private squareSpaceService: SquareSpaceService,
    private transloco: TranslocoService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngAfterViewInit() {
    const element = this.imageZoom?.nativeElement;
    if (element) {
      this.renderer.setStyle(element, 'width', 'auto');
      this.renderer.setStyle(element, 'height', 'auto');
    }
  }

  public ngOnInit(): void {
    this.artistId = this.authService.getUserId();
    this.isAuthenticated = this.authService.isAuthenticated();
    this.isFreePlanUser = this.authService.isFreePlanUser();
    console.log('isFreePlanUser', this.isFreePlanUser)
    this.isSquarePos = this.authService.IsSquarePOS();
    console.log('isSquarePos :', this.isSquarePos)
    this.isShopify = this.authService.IsShopify();
    console.log('isShopify :', this.isShopify)
    this.isWoocommerce = this.authService.IsWoocommerce();
    console.log('isWoocommerce :', this.isWoocommerce)
    this.isWix = this.authService.IsWix();
    console.log('isWix :', this.isWix)
    this.isFacebook = this.authService.IsFacebookAccounts();
    console.log('isFacebook :', this.isFacebook)
    this.isInstagram = this.authService.IsInstagramAccounts();
    this.UserNmae = this.authService.getUserName();
    console.log('isInstagram :', this.isInstagram)

    this.authConfig = this.authService.getAuthConfig();
    this.route.params.subscribe((params) => {
      if (params['artistId']) {
        this.artistId = params['artistId'];
        console.log('artistId  :', this.artistId)

      }
      if (params['artworkId']) {
        this.selectedProductId = params['artworkId'];
        console.log('selectedProductId  :', this.selectedProductId)
        if (this.selectedProductId) {
          this.getArtistProductDetails(this.artistId, this.selectedProductId);
          this.getArtistProductStatus(this.artistId, this.selectedProductId);
          if (this.isAuthenticated && this.selectedProductId) {

            this.getSocialPosts(this.selectedProductId);

          }
          if (this.isAuthenticated && this.selectedProductId && this.authConfig.IsGallery) {
            this.HasAccountOnShopify();
            this.HasAccountOnSquareUp();
            this.HasAccountOnWooCommerce();
            this.hasAccountOnWix();
            this.HasAccountOnSquareSpace();
            // this.allowProductSyncOnShopify();
            // this.allowProductSyncOnSquareUp();
            // this.allowProductSyncOnWooCommerce();
            // this.allowProductSyncOnWix();

            console.log("this.selectedItem.SquarePosProductId ", this.selectedItem.SquarePosProductId)

          }

        }
      }
      this.fetchRelevantProducts();
    });

    this.selectedTabIndex = 0;
    console.log("this.selectedItem.SquarePosProductId ", this.selectedItem.SquarePosProductId)
  }

  private getArtistProductStatus(artistId: string, artistProductId: string,) {
    this.ArtistProductsService.getArtistProductStatus(artistId, artistProductId).subscribe((productStatus: ProductsStatusFiltersType) => {
      this.productStatus = productStatus;
      this.isProductAvailable = this.productStatus == ProductsStatusFilters.Available ? true : false;
      this.isProductSold = this.productStatus == ProductsStatusFilters.Sold ? true : false;
    }, (error) => { console.error(error); });
  }

  public SaveDetail() {
    this.ngxSpinnerService.show();
    this.consignmentProductService.saveSuggestedPriceData(this.artistId, this.selectedProductId, this.consignedProduct).subscribe((response: ResponseObject) => {
      if (response.Success) {
        this.notificationsService.showNotification(this.transloco.translate('viewArtwork.successTitle'), this.transloco.translate('viewArtwork.changesSaved'), NotificationTypes.Success);
      } else { this.notificationsService.showNotification(this.transloco.translate('viewArtwork.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public ChatwithArtist() {
    if (this.selectedItem && this.selectedItem.ArtistId) {
      this.router.navigate(['/inbox', this.selectedItem.ArtistId]);
    } else {
      console.error('Artist ID not available');
    }
  }


  public toggleFullScreenImage() {
    this.showFullScreenImage = !this.showFullScreenImage;
    this.galleria = false;
    this.isTabsVisible = false;
  }

  public closeFullScreenImage() {
    this.showFullScreenImage = false;
    this.galleria = true;
    this.isTabsVisible = true;
  }


  public onSocialPostThumbnailclick(event: Event, imageUrl: string): void {
    if (this.productImages) {
    }
  }

  public onCloseProductSoldDailog($event: boolean) {
    this.isProductSoldDialogVisible = $event
  }

  public onMarkProductAsSold($event: any) {
    $event.stopPropagation();

    this.productSoldData = {
      IsSold: this.selectedItem.IsSold,
      ConsignmentId: this.selectedItem.ConsignmentId,
      ArtistProductId: this.selectedItem.Id,
      SerialNumber: this.selectedItem.SerialNumber,
      ArtistProductName: this.selectedItem.Name,
      ArtistProductImgUrl: this.selectedItem.ProductImgUrl,
      ArtistRevenue: this.selectedItem.ArtistRevenue,
      ShortDescription: this.selectedItem.ShortDescription,
      SuggestedSalePrice: this.selectedItem.SuggestedSalePrice,
      Remarks: this.selectedItem.SuggestedSalePriceRemarks,
      SoldPrice: this.selectedItem.SuggestedSalePrice,  //by default, show the sold price as the suggested price
      RetailPrice: this.selectedItem?.RetailPrice,
    }
    this.isProductSoldDialogVisible = true;
  }

  public onProductSold($event: any) {
    this.isProductSold = true;
    this.productStatus = ProductsStatusFilters.Sold;
  }

  public onProductShareDailog() {
    this.isProductShareDailogVisible = true
  }

  public onCloseProductShareDailog($event: boolean) {
    this.isProductShareDailogVisible = $event
  }

  public ngOnDestroy(): void {
    this.titleService.setTitle("ArtFlow | Admin");
  }

  public onOpenSocialPostDailog() {
    this.isSocialPostDailogVisible = true
    this.getArtistProductImages(this.artistId, this.selectedProductId)
  }

  public onCloseSocialPostDailog() {
    this.isSocialPostDailogVisible = false
  }

  public onCloseSocialPostsDailog($event: boolean) {
    this.isSocialPostDailogVisible = $event
  }

  public onCloseFacebookPostDailog() {
    this.isFacebookPagesDailogVisible = false
    this.facebookAccounts = []
    this.facebookAccountsId = null
    this.facebookPageId = null
    this.selectedFacebookAccount = {} as SocialPostData
    this.selectedFacebookPage = {} as FaceBookOuthPages;

  }

  public onCloseInstagramPostDailog() {
    this.isInstagramPagesDailogVisible = false
    this.instagramAccounts = []
    this.instagramAccountsId = null
    this.selectedInstagramAccount = {} as InstagramAccountsApiResponce

  }

  public onOpenFacebookShare() {
    this.getfacebookAccountProfile();
  }

  public onConnectFacebookAccount() {
    this.ngxSpinnerService.show();
    this.facebookService.onloginWithFacebook().subscribe((response: ResponseObject) => {
      console.log("response", response);
      if (response.Success) {
        window.location.href = response.ResponseData;
      } else {
        this.ngxSpinnerService.hide();
        console.error("Failed to get redirect URL");
      }
      this.ngxSpinnerService.hide();
    }, error => {
      this.ngxSpinnerService.hide();
      console.error("Error during Facebook login:", error);
    });
  }

  public onConnectInstagramAccount() {
    this.ngxSpinnerService.show(); // Show spinner at the start
    this.instagramService.onloginWithInstagram().subscribe(
      (response: ResponseObject) => {
        console.log("response", response);
        if (response.Success) {
          window.location.href = response.ResponseData;
        } else {
          this.ngxSpinnerService.hide();
          console.error("Failed to get redirect URL");
        }
        this.ngxSpinnerService.hide(); // Hide spinner after successful processing
      },
      (error) => {
        console.error("Error during Instagram login:", error);
        this.ngxSpinnerService.hide(); // Hide spinner in case of error
      }
    );
  }

  public onOpenInstagramShare() {
    this.getInstagramAccountProfile();
  }

  public getfacebookAccountProfile() {
    this.ngxSpinnerService.show();
    this.facebookService.onGetAllFacebookAccounts().subscribe((responce: FacebookAccount) => {
      console.log("FacebokAccounts", responce)
      if (responce && responce.FaceBookId) {
        this.ngxSpinnerService.hide();
        this.facebookAccountsId = responce.FaceBookId!
        this.FacebookAccountName = responce.FaceBookName;
        this.FacebookAccountImageUrl = responce.FacebookProfilePicture
        this.FacebookAccountEmail = responce.FaceBookEmail
        this.facebookPages = responce.FaceBookOuthPages
        this.isFacebookPagesDailogVisible = true;
      } else {
        this.ngxSpinnerService.hide();
        this.onConnectFacebookAccount();
        console.error("Empty response array");
      }
    }, (error) => {
      this.ngxSpinnerService.hide();
      console.log(error)
    })
  }

  public getInstagramAccountProfile() {
    this.ngxSpinnerService.show();
    this.instagramService.onGetAllInstagramAccounts(false).subscribe((responce: InstagramAccountsApiResponce[]) => {
      if (responce) {
        this.ngxSpinnerService.hide();
        const account = responce[0];
        this.instagramAccounts = responce
        console.log("instagramAccounts", this.instagramAccounts[0].UserName)
        if (this.instagramAccounts.length === 1) {
          this.selectedInstagramAccount = this.instagramAccounts[0];
        }
        this.isInstagramPagesDailogVisible = true
      } else {
        this.ngxSpinnerService.hide();
        this.onConnectInstagramAccount();
        console.error("Empty response array");
      }
    }, (error) => {
      this.ngxSpinnerService.hide();
      console.log(error)
    })
  }

  public onGetAllFacebookPages(AccountId: string | undefined) {
    this.ngxSpinnerService.show();
    this.SocialPostService.getFacebookProfile(AccountId).subscribe((response: FacebookProfie[]) => {
      console.log("response", response);
      this.ngxSpinnerService.hide();
      if (response.length > 0) {
        const firstItem = response[0];
        if (firstItem.responeObject) {
          const responseObject: ResponeObject = firstItem.responeObject;
          if (responseObject.ResponseData !== undefined) {
            const responseData: any = responseObject.ResponseData;
            if (responseObject.Success) {
              this.facebookPages = firstItem.FaceBookOuthPages
            } else {
            }
          }
        }
      }
    },
      error => {
        console.error("Error fetching Facebook profiles:", error, this.ngxSpinnerService.hide());
      }
    );
  }

  public onGetAllInstagramPages(AccountId: string | undefined) {
    this.ngxSpinnerService.show();
    this.SocialPostService.getInstagramProfile(AccountId).subscribe((response: FacebookProfie[]) => {
      console.log("response", response);
      this.ngxSpinnerService.hide();
      if (response.length > 0) {

        const firstItem = response[0];
        if (firstItem.responeObject) {
          const responseObject: ResponeObject = firstItem.responeObject;
          if (responseObject.ResponseData !== undefined) {
            const responseData: any = responseObject.ResponseData;
            if (responseObject.Success) {
              this.instagramPages = firstItem.InstagramOuthPage
            } else {
            }
          } else {
            console.error("ResponseData is undefined");
          }
        }
      }
    },
      error => {
        console.error("Error fetching Instagram profiles:", error, this.ngxSpinnerService.hide());
      }
    );
  }

  public onOpenFacebookUrl() {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.document.location.href}`;
    window.open(facebookUrl, '_blank');
  }

  public onOpenWhatsappUrl() {
    let content = encodeURIComponent(`${this.document.location.href}`);
    const whatsaap = `https://api.whatsapp.com/send?text=${content}`;
    window.open(whatsaap, '_blank');
  }

  public onOpenInstagramUrl() {
    let instagramUrl = 'https://www.instagram.com/';
    let content = encodeURIComponent(`${this.document.location.href}`);
    window.open(`${instagramUrl}?text=${content}`, '_blank');
  }

  public onOpenPinterestUrl() {
    let pinterestUrl = 'https://www.pinterest.com/pin/create/button/?url=';
    let compleleteUrlShare = encodeURIComponent(this.document.location.href);
    window.open(`${pinterestUrl}${compleleteUrlShare}`, '_blank');
  }

  public getSocialPosts(productId: string) {
    this.ngxSpinnerService.show();
    this.SocialPostService.getSocailPost(productId).subscribe((responce: SocialPost[]) => {
      this.socialPosts = responce
      this.ngxSpinnerService.hide();
    }, (error) => { console.error('Error fetching in social post:', error); this.ngxSpinnerService.hide(); })
  }

  // for account selection
  public onFacebookAccountSelection($event: any) {
    console.log($event)
    if ($event.value) {
      this.facebookAccounts[0].Id = $event.value
      this.selectedFacebookAccount = this.facebookAccounts.find(
        account => account.Id === $event.value
      ) || {} as SocialPostData;
      console.log(this.facebookAccounts[0].Id)
      // Fetch associated Facebook pages
      this.onGetAllFacebookPages(this.selectedFacebookAccount?.Id);
    } else {
      console.log("id is null")
      this.facebookAccountsId = null
      this.selectedFacebookAccount = {} as SocialPostData;
      this.facebookPages = []
      this.facebookPageId = null
    }
  }
  public onInstagramAccountSelection($event: any) {
    console.log($event)
    if ($event.value) {
      this.instagramAccountsId = $event.value
      this.instagramAccounts[0].InstaUserId = $event.value
      this.selectedInstagramAccount = this.instagramAccounts.find(
        account => account.InstaUserId === $event.value
      );
      console.log(this.instagramAccounts[0].InstaUserId)
      // Fetch associated Instagram pages
      // this.onGetAllInstagramPages(this.selectedInstagramAccount?.Id);
    } else {
      console.log("id is null")
      this.instagramAccountsId = null
      this.selectedInstagramAccount = {} as InstagramAccountsApiResponce;
      this.instagramPages = []
      this.instagramPageId = null
    }
  }
  // for page selection
  public onFacebookPageSelection($event: any) {
    console.log($event)
    this.facebookPageId = $event.value
  }
  public onInstagramPageSelection($event: any) {
    console.log($event)
    this.instagramPageId = $event.value
  }
  onBasicUploadAuto(event: UploadEvent) {
    this.messageService.add({ severity: 'info', summary: this.transloco.translate('viewArtwork.successTitle'), detail: this.transloco.translate('viewArtwork.fileUploadedAuto') });
  }

  public postOnFacebook() {
    if (this.selectedFacebookPage) {
      console.log('Posting on Facebook:', this.selectedFacebookPage);
      console.log(this.galleryDescription.GalleryShortDescription)
      this.facebookPost.facebookId = this.facebookAccountsId!
      this.facebookPost.faceBookPageId = this.facebookPageId!
      this.facebookPost.productId = this.selectedItem.Id
      this.facebookPost.headline = this.selectedItem.SerialNumber + '-' + this.selectedItem.Name
      this.facebookPost.description = this.galleryDescription.GalleryShortDescription
      this.facebookPost.imageURL = this.selectedItem.ProductImgUrl
      console.log(this.facebookPost)
      this.ngxSpinnerService.show();
      this.facebookService.onPostPublish(this.facebookPost).subscribe((responce: ResponseObject) => {
        console.log(responce)
        if (responce.Success) {
          this.ngxSpinnerService.hide();
          this.notificationsService.showNotification(this.transloco.translate('viewArtwork.successTitle'), responce.ResponseMessage, NotificationTypes.Success);
          this.onCloseFacebookPostDailog()
          this.onCloseSocialPostDailog();
          this.getSocialPosts(this.selectedItem.Id);
        } else { this.ngxSpinnerService.hide(); this.notificationsService.showNotification(this.transloco.translate('viewArtwork.errorTitle'), responce.ResponseMessage, NotificationTypes.Error); }
        this.ngxSpinnerService.hide();
      }, (error) => { console.error(error); this.ngxSpinnerService.hide(); })
    }
  }

  public postOnInstagram() {
    if (this.selectedInstagramAccount) {
      console.log('Posting on Instagram:', this.selectedInstagramAccount);
      this.SocialPost.productId = this.selectedItem.Id
      this.SocialPost.headLine = this.selectedItem.SerialNumber + '-' + this.selectedItem.Name
      this.SocialPost.description = this.selectedItem.GalleryShortDescription
      this.SocialPost.imageURL = this.selectedItem.ProductImgUrl
      this.SocialPost.instagramId = this.selectedInstagramAccount.Id
      console.log(this.SocialPost)
      this.ngxSpinnerService.show();
      this.instagramService.onPostPublish(this.SocialPost).subscribe((responce: ResponseObject) => {
        console.log(responce)
        if (responce.Success) {
          this.ngxSpinnerService.hide();
          this.notificationsService.showNotification(this.transloco.translate('viewArtwork.successTitle'), responce.ResponseMessage, NotificationTypes.Success);
          this.onCloseInstagramPostDailog()
          this.onCloseSocialPostDailog();
          this.getSocialPosts(this.selectedItem.Id);
        } else { this.ngxSpinnerService.hide(); this.notificationsService.showNotification(this.transloco.translate('viewArtwork.errorTitle'), responce.ResponseMessage, NotificationTypes.Error); }
        this.ngxSpinnerService.hide();
      }, (error) => { console.error(error); this.ngxSpinnerService.hide(); })
    }
  }


  // Method to check if the image is the selected one


  private getArtistProductImages(artistId: string, artistProductId: string | null) {
    this.ArtistProductsService.getArtistProductImages(artistId, artistProductId).subscribe((productImages: ArtistProductImage[]) => {
      this.productImages = productImages;
      console.log('this.productImages', this.productImages)
    }, (error) => { console.error(error); });
  }

  public handleImageHover(productImage: ArtistProductImage, isHovered: boolean) {
    this.productImages.forEach(img => img.hovered = false); // Set hover to false for all images
    productImage.hovered = isHovered; // Set hover to true for hovered image
  }

  public updateSocialPostCoverimage(selectedProduct: ArtistProductImage) {
    var data: CoverPhotoResponse = {
      ProductId: selectedProduct.ArtistProductId,
      CoverImageUrl: selectedProduct.ImageUrl
    };
    this.selectedItem.ProductImgUrl = data.CoverImageUrl;

    // Reset hover states when an image is selected
    this.productImages.forEach(img => img.hovered = false);
  }

  public isImageSelected(productImage: ArtistProductImage): boolean {
    return productImage.ImageUrl === this.selectedItem.ProductImgUrl;
  }

  public deleteImage(selectedImageData: ArtistProductImage) {
    this.confirmationService.confirm({
      accept: () => {
        this.ngxSpinnerService.show();
        this.ArtistProductsService.deleteImage(selectedImageData.Id).subscribe((response) => {
          this.ngxSpinnerService.hide();
          if (response.Success) {
            this.getArtistProductImages(this.artistId, this.selectedProductId);
            this.notificationsService.showNotification(this.transloco.translate('viewArtwork.successTitle'), this.transloco.translate('viewArtwork.filesDeleted'), NotificationTypes.Success);
          } else {
            this.notificationsService.showNotification(this.transloco.translate('viewArtwork.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
          }
        }, (error) => {
          console.error(error);
          this.ngxSpinnerService.hide();
        });
      }
    });
  }

  public onFileSelected(files: File[], isAdditionalImage: boolean) {
    if (files.length > 0) {
      //check the type of file user is uploading which will help us in deciding whether we need to show the image cropper or not.
      this.currentSelectedImageToCrop = files[0];
      const isImage: boolean = this.currentSelectedImageToCrop['type'].includes('image');

      if (isImage && this.enableCropper) {
        this.isAdditionalImage = isAdditionalImage;
        //open the cropper dialog only when the user selected an image
        this.showCropperDialog = true;
      }
    }

  }

  //gets called as an output parameter of image-cropper whenever user crops the image on image-crop dialog.
  public onImageCropped($cropResponse: ImageCroppedResponse) {
    console.log($cropResponse);
    this.isAdditionalImage = false;
    this.showCropperDialog = false;

    this.selectedFile = $cropResponse.CroppedImage;
    if (this.selectedFile) {
      //upload the cropped cover image
      const formData = new FormData();
      formData.append('ImageFile', this.selectedFile);
      this.ngxSpinnerService.show();
      this.uploadService.uploadImage(formData).subscribe((imageUrl: string) => {
        if (this.selectedProductId) {
          if ($cropResponse.IsAdditionalImage) {
            //incase the user has uploaded the additional image (not the cover photo), connect it as an additional image
            this.ngxSpinnerService.show();
            //after they have been uploaded, connect them with the product so we don't have to save them on "Save" click
            this.ArtistProductsService.connectUploadedImages(this.artistId, this.selectedProductId, [imageUrl], this.authConfig.IsArtist ? false : true).subscribe((response: ResponseObject) => {
              if (response.Success) {
                console.log(response.ResponseData)
                //refresh the product images
                this.getArtistProductImages(this.artistId, this.selectedProductId);

                this.notificationsService.showNotification(this.transloco.translate('viewArtwork.successTitle'), this.transloco.translate('viewArtwork.imageUploaded'), NotificationTypes.Success);
              } else { this.notificationsService.showNotification(this.transloco.translate('viewArtwork.errorTitle'), this.transloco.translate('viewArtwork.saveDataError'), NotificationTypes.Error); }
              this.ngxSpinnerService.hide();
            }, error => { console.error(error); this.ngxSpinnerService.hide(); });
          } else {
            //incase the user has uploaded the cover photo
            //after the cover has been uploaded, connect them with the product so we don't have to save them on "Save" click
            this.ArtistProductsService.connectProductCoverImage(this.artistId, this.selectedProductId, imageUrl).subscribe((response: ResponseObject) => {
              if (response.Success) {
                this.selectedItem.ProductImgUrl = imageUrl;
                this.notificationsService.showNotification(this.transloco.translate('viewArtwork.successTitle'), this.transloco.translate('viewArtwork.productCoverUploaded'), NotificationTypes.Success);
              } else { this.notificationsService.showNotification(this.transloco.translate('viewArtwork.errorTitle'), this.transloco.translate('viewArtwork.saveDataError'), NotificationTypes.Error); }
              this.ngxSpinnerService.hide();
            }, error => { console.error(error); this.ngxSpinnerService.hide(); });
          }
        } else {
          //since we are creating a new product, so we can't connect the uploaded image to a product right now
          this.selectedItem.ProductImgUrl = this.productImage.ImageUrl;
          this.ngxSpinnerService.hide();
        }
      }, error => { console.error(error); this.ngxSpinnerService.hide(); });

    }
  }

  public additionalFiles: any[] = [];

  public onImageCropperClose($event: any) {
    this.showCropperDialog = false;
    if ($event.skipCropping) {
    }
  }
  public onAdditionalFileCleard($event: any) {
    this.additionalFiles = [];
  }




  public viewArtistDetails(ArtistUserName: string) {
    console.log('userName', ArtistUserName)
    this.router.navigate(['/profile', ArtistUserName]);
  }

  GalleryDescription: GalleryDescriptionResponse = {
    GalleryShortDescription: '',
    GalleryLongDescription: '',
    GallerySocialMediaDescription: ''
  };


  private getArtistProductDetails(artistId: string, artistProductId: string) {
    this.ngxSpinnerService.show();
    this.ArtistProductsService.viewArtistProductDetail(artistId, artistProductId).subscribe((artistProduct: ViewArtistProductResponse) => {
      this.selectedItem = artistProduct;
      console.log('===== API Response - Product Details =====');
      console.log('Full Response:', this.selectedItem);
      console.log('ArtistProductLogs from API:', this.selectedItem?.ArtistProductLogs);
      console.log('ArtistProductLogs count:', this.selectedItem?.ArtistProductLogs?.length);
      console.log('=============================');
      if (this.authConfig.IsArtist) {
        this.items = [{ label: 'ArtWork', routerLink: ['/artists', 'artworks'] },
        { label: this.selectedItem.Name }];
      }
      if (this.authConfig.IsGallery) {
        this.items = [{ label: 'ArtWork', routerLink: ['/'] },
        { label: this.selectedItem.Name }];
      }

      this.home = { icon: 'pi pi-home', routerLink: '/' };

      if (this.selectedItem && this.selectedItem.ProductImgUrl) {
        let metaImage = this.selectedItem.ProductImgUrl;
        if (metaImage.startsWith('https://res.cloudinary.com')) {
          const uploadIndex = metaImage.indexOf("/upload");
          metaImage = metaImage.slice(0, uploadIndex + 7) + "/ar_16:9,b_white,c_pad" + metaImage.slice(uploadIndex + 7);
        }
        this.titleService.setTitle(`${this.selectedItem.Name} | Artflow`);
        this.updateMetaTags(metaImage);
      }

      // Update consigned product details
      this.consignedProduct.SuggestedSalePrice = this.selectedItem.SuggestedSalePrice;
      this.consignedProduct.Remarks = this.selectedItem.SuggestedSalePriceRemarks;
      // Set gallery descriptions
      this.setGalleryDescriptions();
      this.ngxSpinnerService.hide();
    }, (error) => {
      console.error(error);
      this.ngxSpinnerService.hide();
    });
  }

  private updateMetaTags(metaImage: string) {
    this.metaService.updateTag({ property: "og:title", content: this.selectedItem.Name });
    this.metaService.updateTag({ property: "og:description", content: this.selectedItem.ShortDescription });
    this.metaService.updateTag({ property: 'og:image', content: metaImage, itemprop: 'image' });
    this.metaService.updateTag({ property: 'og:image:secure_url', content: metaImage, itemprop: 'image' });
    this.metaService.updateTag({ property: 'og:image:url', content: metaImage, itemprop: 'image' });
    this.metaService.updateTag({ property: 'og:url', content: this.document.location.href });
  }

  private setGalleryDescriptions() {
    // Use artist descriptions if gallery descriptions are missing
    this.galleryDescription.GalleryShortDescription = this.selectedItem.GalleryShortDescription || this.selectedItem.ShortDescription;
    this.galleryDescription.GalleryLongDescription = this.selectedItem.GalleryLongDescription || this.selectedItem.LongDescription;
    this.galleryDescription.GallerySocialMediaDescription = this.selectedItem.GallerySocialMediaDescription || this.selectedItem.SocialMediaDescription;
  }

  public showChatGPTDialog($event: any) {
    this.showchatGPTDialog = true;
  }

  public onUseGeneratedProductSuggestions($event: GeneratedProductDescriptionsSuggestions) {
    if ($event.ShortDescription) {
      this.selectedItem.GalleryShortDescription = $event.ShortDescription;
      this.GalleryDescription.GalleryShortDescription = $event.ShortDescription;
    }
    if ($event.MarketingDescription) {
      this.selectedItem.GalleryLongDescription = $event.MarketingDescription;
      this.GalleryDescription.GalleryLongDescription = $event.MarketingDescription;
    }
    if ($event.SocialMediaPostDescription) {
      this.selectedItem.GallerySocialMediaDescription = $event.SocialMediaPostDescription;
      this.GalleryDescription.GallerySocialMediaDescription = $event.SocialMediaPostDescription;
    }

    // Save the generated descriptions to the gallery
    this.ArtistProductsService.saveGalleryDescription(this.selectedItem.ArtistId, this.selectedItem.Id, this.GalleryDescription)
      .subscribe(response => {
        if (response.Success) {
          console.log('Gallery description saved successfully');
          this.getArtistProductDetails(this.selectedItem.ArtistId, this.selectedItem.Id);

        } else {
          console.error('Error saving gallery description:', response.ResponseMessage);
        }
      }, error => {
        console.error('Error saving gallery description:', error);
      });

    // Close the ChatGPT dialog
    this.closechatGPTDialog({});
  }

  public closechatGPTDialog($event: any) {
    this.showchatGPTDialog = false;
  }

  public activeIndex: number = 0;
  onThumbnailClick(item: string): void {
    const index = this.selectedItem.ArtistProductImages.indexOf(item);
    if (index !== -1) {
      this.activeIndex = index;
      this.selectedItem.ProductImgUrl = item;
    }
  }

  public preventNegativeValues(event: any): void {
    let value = event.target.value;
    value = value.replace(/-/g, '');
    // Allow only valid decimal numbers (positive values with an optional decimal point)
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (!regex.test(value)) {
      // If invalid, revert to previous valid value or set to empty string
      this.consignedProduct.SuggestedSalePrice = 0;
    } else {
      // Ensure value remains a valid positive decimal number
      this.consignedProduct.SuggestedSalePrice = value;
    }
    if (event.target.value < 0) {
      // event.target.value = 0;
      this.consignedProduct.SuggestedSalePrice = 0
    }
  }
  public onCloseDialog(): void {
    this.displayCurrencyDialog = false;
  }

  public fetchRelevantProducts(): void {
    this.RelevantProducts = [];
    this.ArtistProductsService.createRelevantProduct(this.selectedProductId!, 6).subscribe(
      (response: ViewArtistProductResponse[]) => {
        console.log('Fetched relevant products:', response);
        this.RelevantProducts = response;
      },
    );
  }

  public showProductDetail(artistProduct: ViewArtistProductResponse) {
    this.router.navigate([artistProduct.ArtistId, 'artworks', artistProduct.Id]);
  }

  private HasAccountOnShopify() {
    this.ShopifyService.hasAccountOnShopify().subscribe(
      (accountExists: ShopifyOAuthToken) => {
        this.shopifyAccount = accountExists;
        console.log('shopifyAccount', this.shopifyAccount)
      },
      (error) => { console.error(error); }
    );
  }

  public hasAccountOnWix(): void {
    this.wixService.hasAccountOnWix().subscribe(
      (res) => {
        if (res.Success) {
          const accountExists = res.Success;
          console.log('Wix account exists:', accountExists);
          this.checkAccountExitsOnWix = accountExists
        }
      },
      (error) => { console.error(error); }
    );
  }

  private HasAccountOnSquareUp() {
    this.squareupPosService.hasAccountOnSquareUp().subscribe(
      (accountExists: SquareUpOAuthTokken) => {
        this.squareUpAccount = accountExists;
        console.log('squareUpAccount', this.squareUpAccount)

      },
      (error) => { console.error(error); }
    );
  }
  private HasAccountOnWooCommerce() {
    this.WoocomerceService.hasAccountOnWooCommerce().subscribe(
      (accountExists: WoocommerceCredentials) => {
        this.wooCommerceAccount = accountExists;
        console.log('wooCommerceAccount', this.wooCommerceAccount)

      },
      (error) => { console.error(error); }
    );
  }
  private HasAccountOnSquareSpace() {
    this.squareSpaceService.hasAccountOnSquareSpace().subscribe((response) => {
      if (response.Success) {
        this.checkAccountOnSquareSpace = true;
      } else {
        this.checkAccountOnSquareSpace = false;
      }
    })
  }

  public onConnectSquareupPosAccount() {
    this.router.navigate(['/connect-squareup-pos-account']);
  }

  public connectWithsquarespace() {
    this.router.navigate(['/connect-with-squarespace-account']);
  }

  public connectWithWixAccount() {
    this.router.navigate(['/connect-with-wix-account']);
  }

  public onUpgradePlan() {
    this.isStripeDisplayPlansDialogVisible = true
  }
  public onCloseStripePaymentDailog($event: boolean) {
    this.isStripeDisplayPlansDialogVisible = $event;
  }

  public onSidebarHidden(event: Event): void {
    console.log('Sidebar closed!', event);
  }

  public goToArtworkAndSyncAll() {
    this.router.navigate(['/galleries', 'gallery-products'])
  }

  public onShowShopifyConnectionDailog() {
    this.isShopifyConnectionDailogVisible = true
  }

  public onCloseShopifyConnectionDailog($event: boolean) {
    this.isShopifyConnectionDailogVisible = $event
  }

  public onShowWoocommerceAccountDailog() {
    this.isAddWoocommerceAccountDailogVisible = true
  }

  public onCloseWoocommerceAccountDailog($event: boolean) {
    this.isAddWoocommerceAccountDailogVisible = $event
  }

  public openActivityLogSidebar(): void {
    this.sidebarActivityLogsVisible = true;
    console.log('===== Activity Log Debug =====');
    console.log('selectedItem:', this.selectedItem);
    console.log('ArtistProductLogs:', this.selectedItem?.ArtistProductLogs);
    console.log('ArtistProductLogs length:', this.selectedItem?.ArtistProductLogs?.length);
    console.log('IsGalleryProduct:', this.selectedItem?.IsGalleryProduct);
    console.log('IsArtistOwnProduct:', this.selectedItem?.IsArtistOwnProduct);
    console.log('=============================');
  }

  public checkAndSyncProduct(platform: string): void {
    this.platform = platform;
    console.log(this.platform, '');
    switch (platform) {
      case 'SquareUp':
      case 'Shopify':
      case 'WooCommerce':
      case 'Wix':
      case 'SquareSpace':
        this.displayCurrencyDialog = true;
        break;
    }
  }

  public openShopifyLinksDialog(): void {
    this.shopifyLinksDialogVisible = false;
    setTimeout(() => {
      this.shopifyLinksDialogVisible = true;
      this.cdRef.detectChanges(); // Force refresh
    });
  }

  public openWooCommerceLinksDialog(): void {
    this.wooCommerceLinksDialogVisible = false;
    setTimeout(() => {
      this.wooCommerceLinksDialogVisible = true;
      this.cdRef.detectChanges(); // Force refresh

    });
  }

  public openSquareSpaceLinksDialog(): void {
    this.squareSpaceLinksDialogVisible = false;
    setTimeout(() => {
      this.squareSpaceLinksDialogVisible = true;
      this.cdRef.detectChanges(); // Force refresh
    });
  }

  public get shopifyStores(): ProductSyncedOnPlatformDTO[] {
    return (this.selectedItem?.ProductSyncedOnPlatformDTOs || []).filter(dto => dto.PlatformName === 'Shopify');
  }

  public get wooCommerceStores(): ProductSyncedOnPlatformDTO[] {
    return (this.selectedItem?.ProductSyncedOnPlatformDTOs || []).filter(dto => dto.PlatformName === 'WooCommerce');
  }
  public get squareSpaceStores(): ProductSyncedOnPlatformDTO[] {
    return (this.selectedItem?.ProductSyncedOnPlatformDTOs || []).filter(dto => dto.PlatformName === 'SquareSpace');
  }

}


